import React from 'react'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Select from 'react-select';
import {
    cadastrarUsuariosEmpresaEmLote,
    limparRetornocadastramentoUsuariosEmpresaEmLote
} from '../../../actions/usuario/cadastrarUsuariosEmpresaEmLote'
import alterarUsuario from '../../../actions/usuario/alterarUsuario'
import selecionarPerfis from '../../../actions/perfil/selecionarPerfis';
import limparPerfis from '../../../actions/perfil/limparPerfis';
import {
    renderFieldCheck,
    renderFieldNumerosPorcentagem,
    renderTextArea2,
    required,
    tamanhoPorcentagem
} from '../../../util/inputs';
import buscarUsuarioPorEmail from '../../../actions/usuario/buscarUsuarioPorEmail';
import {buscarPerfis} from '../../../actions/usuario/buscarUsuarios';
import {showSuccessMsg} from '../../../util/messagesUtil';
import {getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa, PERFIL_ADMIN} from '../../../security/securityContext';
import Titulo from '../../comum/Titulo';
import Autorizacao from '../../../security/Autorizacao';
import validator from 'validator'

const OPCAO_DESCONTO_MEIA_PASSAGEM = [
    {label: 'Aplicar desconto no valor da Empresa', value: 'EMPRESA'},
    {label: 'Aplicar desconto no valor da ANTT', value: 'ANTT'},
    {label: 'Aplicar desconto no valor da ANTT e Empresa', value: 'ANTT_EMPRESA'}];

export class ModalCadastrarUsuario extends React.Component {
    constructor(props) {
        super(props);
        this.fechar = this.fechar.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.submit = this.submit.bind(this);
        this.state = {
            usuario: '',
            perfisSelecionados: [],
            perfis:[],
            emails: []
        };
    }

    componentDidMount() {
        this.props.limparRetornocadastramentoUsuariosEmpresaEmLote();
        this.props.buscarPerfis().then(resp => this.setState({perfis: resp.payload.data}));
        this.limparFormulario();
    }

    exibirComboOpcaoDescontoMeiaPassagem(event) {
        if (!this.props.opcaoDescontoMeiaPassagem) {
            this.props.changeFieldValue('formularioCadastroUsuarioEmLote',
                'opcaoDescontoMeiaPassagem', {label: 'Aplicar desconto no valor da ANTT', value: 'ANTT'});
        }

        return (
            <div>
                <Select
                    {...event.input}
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    placeholder='Adicionar uma opção de desconto'
                    options={OPCAO_DESCONTO_MEIA_PASSAGEM}
                    onChange={(value) => {
                        event.input.onChange(value);
                    }}
                    onBlur={() => event.input.onBlur()}
                />
                {event.meta.touched
                && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
            </div>
        )
    }

    exibirComboPerfil() {
        return (
            <div>
                <Select
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    value={this.state.perfisSelecionados}
                    isMulti
                    placeholder=''
                    options={this.state.perfis}
                    onChange={event => this.setState({perfisSelecionados: [...event]})}
                />
            </div>
        )
    }

    exibirOpcaoDescontoMeiaPassagemo() {
        const vendedor = this.state.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            return (
                <div className="form-row mt-2">
                    <div className="col-12 col-sm-9 col-md-6">
                        <label>Opções de desconto de meia passagem </label>
                        <Field name='opcaoDescontoMeiaPassagem' required={true}
                               component={this.exibirComboOpcaoDescontoMeiaPassagem.bind(this)}/>
                    </div>
                </div>
            )
        }
        return ''
    }

    adicionarPerfil(perfil) {
        const perfis = Object.assign([], this.state.perfisSelecionados);
        const perfiJaExiste = perfis.filter(f => f.value === perfil.value);
        if (perfiJaExiste.length === 0) {
            perfis.push(perfil);
            this.props.selecionarPerfis(perfis)
        }
    }

    exibirComissao() {
        const vendedor = this.state.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo === 'TCB' || this.props.empresaSelecionada.grupo === 'CIDAO') {
                return <div className="form-group">
                    <label>Comissão(%)</label>
                    <input type="text" className="form-control col-md-2" readOnly={true} value='08.38' name='comissao'/>
                </div>
            }
            return <div className="form-group">
                <Field name='comissao' disabled validate={[required, tamanhoPorcentagem]}
                       component={renderFieldNumerosPorcentagem}
                       css="form-control col-md-2" label="Comissão(%)"/>
            </div>
        }
        this.props.changeFieldValue('formularioCadastroUsuarioEmLote',
            'comissao', '');

        return ''
    }

    exibirVenderValorAntt() {
        const vendedor = this.state.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            return <div className="form-row mt-2">
                <div className="col-12 col-sm-9 col-md-9">
                    <Field name='venderValorANTT' type="checkbox" component={renderFieldCheck}
                           label="Vender com valor antt"
                           css="form-check-input" readOnly={false}/>
                </div>
            </div>
        }

        return ''
    }


    exibirImpostoRetidoUsuaio() {
        const vendedor = this.state.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo === 'TCB' || this.props.empresaSelecionada.grupo === 'BUSER' || this.props.empresaSelecionada.grupo === 'CIDAO') {
                return <div className="form-group">
                    <label>Imposto retido(%)</label>
                    <input type="text" className="form-control col-md-2" readOnly={true} value='16.25' name='comissao'/>
                </div>
            }
            return <div className="form-group">
                <Field name='impostoRetido' validate={[required, tamanhoPorcentagem]}
                       component={renderFieldNumerosPorcentagem}
                       css="form-control col-md-2" label="imposto retido(%)"/>
            </div>
        }
        this.props.changeFieldValue('formularioCadastroUsuarioEmLote',
            'impostoRetido', '');

        return ''
    }

    montarParametroUsuario(values) {
        return {
            empresaId: this.props.empresaSelecionada.id,
            emails: this.state.emails,
            roles: this.state.perfisSelecionados.map(perfil => perfil.value),
            comissao: values.comissao,
            impostoRetido: values.impostoRetido,
            venderValorANTT: values.venderValorANTT,
            tipoDescontoMeiaPassagem: values.opcaoDescontoMeiaPassagem ? values.opcaoDescontoMeiaPassagem.value : 'EMPRESA'
        };
    }

    submit(values) {
        this.props.cadastrarUsuariosEmpresaEmLote(this.montarParametroUsuario(values))
            .then(() => {
                showSuccessMsg('Usuario cadastrado com sucesso');
                this.limparFormulario();
            })
    }

    limparFormulario() {
        this.props.reset('formularioCadastroUsuarioEmLote');
        this.setState({perfisSelecionados: [], emails: []});
        this.props.limparPerfis();
    }


    fechar() {
        this.setState({paginaAtual: 1});
        this.limparFormulario();
        this.props.limparPerfis();
    }

    adicionarEmails(event) {
        event.preventDefault();
        let map = this.props.emails.replace(/\s/g, '').split(',');
        this.setState({emails: map.filter(j => validator.isEmail(j))});
        this.props.changeFieldValue('formularioCadastroUsuarioEmLote',
            'emails', '');
    }

    removerEmail(email) {
        this.setState({emails: this.state.emails.filter(it => it !== email)})
    }

    exibirEmails() {
        return <table className="table table-sm table-bordered mt-4">
            <thead>
            <tr colSpan='3' className='text-center'>
                <th colSpan='3'>E-mails informados</th>
            </tr>
            </thead>
            <tbody>
            {!this.state.emails || this.state.emails.length === 0 ?
                <tr colSpan='3' className="alert alert-warning text-center mt-4" role="alert">
                    <td> Nenhum e-mail informado.</td>
                </tr>
                :
                this.state.emails
                    .map((email, index) => <tr key={email}>
                        <td>
                            {index + 1}
                        </td>
                        <td>
                            {email}
                        </td>
                        <td className='text-center' style={{cursor: 'pointer', color: 'red'}}>
                            <div onClick={() => this.removerEmail(email)}>Remover</div>
                        </td>
                    </tr>)}
            </tbody>
        </table>
    }

    exibirCadastramento() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;
        return <form onSubmit={handleSubmit(this.submit)}>
            <div className="form-row">
                <div className="col-12 col-sm-9 col-md-6">
                    <label>Perfil usuário</label>
                    <Field id='perfil' name='perfil'
                           component={this.exibirComboPerfil.bind(this)}/>
                </div>
            </div>
            {this.exibirVenderValorAntt()}
            {this.exibirComissao()}
            {this.exibirImpostoRetidoUsuaio()}
            {this.exibirOpcaoDescontoMeiaPassagemo()}
            <div className="form-row mt-2">
                <div className="col-12 col-sm-6 col-md-6">
                    <Field name="emails" type="email" component={renderTextArea2}
                           label="E-mails (Separados por vírgula):"
                           css="form-control" readOnly={false}/>

                </div>
                <div className="col-12 col-sm-6 col-md-6 d-flex align-items-center">
                    <button className="btn btn-sm btn-laranja" disabled={!this.props.emails}
                            onClick={(event) => this.adicionarEmails(event)}>Adicionar
                    </button>

                </div>
            </div>
            <div>
                {this.exibirEmails()}
            </div>
            <div className="modal-footer">
                <button id="btn-salvar" type="submit"
                        disabled={invalid || submitting || !this.state.emails.length || !this.state.perfisSelecionados.length}
                        className="btn btn-laranja">Salvar
                </button>
            </div>
        </form>
    }

    exibirRetornoProcessamento() {
        return <div className="lista-table">
            <table className="table table-striped table-bordered" data-show-print={true}>
                <thead>
                <tr>
                    <td colSpan={2} className='text-center'><strong>Resultado do processamento</strong>
                    </td>
                </tr>
                <tr>
                    <th>E-mail</th>
                    <th>Situação</th>
                </tr>
                </thead>
                <tbody>
                {this.props.retornoCadatramentoEmLote.map((retorno, index) => <tr key={'retorno' + index}>
                    <td>{retorno.email}</td>
                    <td>{retorno.situacao}</td>
                </tr>)}
                </tbody>
            </table>
            <button className="btn btn-laranja"
                    onClick={() => {
                        this.limparFormulario();
                        this.props.limparRetornocadastramentoUsuariosEmpresaEmLote()
                    }}>Voltar
            </button>
        </div>
    }

    render() {
        return (
            <div>
                <div className="row internas">
                    <Titulo texto="Cadastro de usuários em lote" urlRetorno="/painel-usuarios"/>
                </div>
                <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id),
                    getOperadorEmpresa(this.props.empresaSelecionada.id),
                    getGestorEmpresa(this.props.empresaSelecionada.id)]}
                    empresaSelecionada={this.props.empresaSelecionada}>
                    {this.props.retornoCadatramentoEmLote ? this.exibirRetornoProcessamento() : this.exibirCadastramento()}
                </Autorizacao>
            </div>
        )
    }
}

export function mapStateToProps(state) {
    return {
        opcaoDescontoMeiaPassagem: formValueSelector('formularioCadastroUsuarioEmLote')(state, 'opcaoDescontoMeiaPassagem'),
        emails: formValueSelector('formularioCadastroUsuarioEmLote')(state, 'emails'),
        empresaSelecionada: state.empresaSelecionada,
        paginaAtual: state.paginaAtualUsuario,
        registrosPorPagina: state.registrosPorPaginaUsuario,
        retornoCadatramentoEmLote: state.usuariosEmpresa.retornoCadatramentoEmLote
    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarUsuariosEmpresaEmLote,
        selecionarPerfis,
        buscarUsuarioPorEmail,
        alterarUsuario,
        limparPerfis,
        buscarPerfis,
        limparRetornocadastramentoUsuariosEmpresaEmLote
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastroUsuarioEmLote'
})(ModalCadastrarUsuario));
